// src/pages/ServerError.js
import React from "react";

const Page500 = () => (
  <div className="server-error">
    <div className="server-error-content">
      <h1 className="server-error-title">500</h1>
      <p className="server-error-message">
        Sorry, something went wrong on our end.
      </p>
      <a className="server-error-link" href="/">
        Go to Homepage
      </a>
    </div>
  </div>
);

export default Page500;
